import { NGXAjax } from '../../common/Services/AjaxService.js';
import { resolve, reject } from './util/api-util';

function fetchFeeds(containerRef, feedType) {
  switch (feedType.toLowerCase()) {
    case 'metric':
      return fetchMetricFeeds(containerRef);
    default:
      return undefined;
  }
}

function fetchMetricFeeds(containerRef) {
  const url = '/api/xmetric/list',
    params = {
      containerRef: containerRef,
      sourceType:   'source.feed',
    };
  return NGXAjax.cronos.get(url, params, { cache: false }).then(resolve, reject);
}

export { fetchFeeds };
